<div class="doc-guide-page">
  <div class="doc-guide-banner">
    <div class="doc-guide-banner-title">{{ title }}</div>
    <div class="doc-guide-banner-subtitle" *ngIf="subtitle">{{ subtitle }}</div>
  </div>

  <div class="doc-guide-body" *ngIf="!loading && !error">
    <div [innerHTML]="content"></div>
  </div>

  <div class="doc-guide-loading" *ngIf="loading">
    <span>Loading guide&hellip;</span>
  </div>

  <div class="doc-guide-error" *ngIf="error && !loading">
    Unable to load this guide right now. Please try again later.
  </div>
</div>
